import React, {  } from 'react';
import { Form, Input } from 'antd';



const { TextArea } = Input;


export default function PodatZayavlenieNaOtmenuRegistratsiiOrganizatoraFederatsiiVEtomRegOt(props) {
    const { object } = props;

    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                organizatorID: object.ID
            }}
        >
            <Form.Item
                preserve={"true"}
                hidden={true}
                name={"organizatorID"}
                label={"Организатор"}
                rules={[{ required: true, message: 'Укажите организатора!' }]}
            >
                <Input disabled />
            </Form.Item>
            <Form.Item
                name={"prichinaTekst"}
                label={"Причина"}
                rules={[{ required: true, message: 'Укажите причину!' }]}
            >
                <TextArea rows={4} />
            </Form.Item>
        </Form>
    );
}
